import React from 'react';
import { connect } from 'react-redux'

import { Table, Row, Col, Button, Dropdown, Pagination, Tag } from 'antd';
import { SettingOutlined, DownCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, EditOutlined, DeploymentUnitOutlined } from '@ant-design/icons';

import { getParamTable, _tableLogActivity } from '../../../../lib/Helper';

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action
    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  sorter: false,
                  width: '2%',
                }, {
                  title: 'Nama',
                  dataIndex: 'nama',
                  sorter: false,
                }, {
                  title: 'Kategori',
                  dataIndex: 'kategori',
                  sorter: false,
                }, {
                  title: 'Tahun Ajaran',
                  dataIndex: 'tahun_ajaran',
                  sorter: false,
                }, {
                  title: 'Pendaftaran',
                  dataIndex: 'tgl_pendaftaran',
                  sorter: false,
                }, {
                  title: 'Seleksi Administrasi',
                  dataIndex: 'tgl_seleksi_administrasi',
                  sorter: false,
                }, {
                  title: 'Seleksi Wawancara',
                  dataIndex: 'tgl_seleksi_wawancara',
                  sorter: false,
                }, {
                  title: 'Seleksi Tulis',
                  dataIndex: 'tgl_seleksi_tulis',
                  sorter: false,
                }, {
                  title: 'Pengumuman',
                  dataIndex: 'tgl_pengumuman',
                  sorter: false,
                }, {
                  title: 'Registrasi',
                  dataIndex: 'tgl_registrasi',
                  sorter: false,
                }, {
                  title: 'Status',
                  dataIndex: 'is_open',
                  sorter: false,
                  render: (a, row) => <>
                    {row.is_open === "1" ? <Tag color="blue" icon={<CheckCircleOutlined />}>Aktif</Tag> : <Tag color="red" icon={<CloseCircleOutlined />}>Tidak Aktif</Tag>}
                  </>,
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => (!action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.update ? [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.update ? [{
    key: 1,
    icon: <DeploymentUnitOutlined />,
    label: "Mapping Berkas Persyaratan",
    onClick: this.props.modalMappingBerkasPersyaratan.bind(this, true, row)
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                }, {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                }
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Desktop);
